/**
 * Formats the strings via index for example, "{0}" substitution
 * @param str
 * @param args
 */
export const format = (str: string, args: any[]) =>
    str.replace(/{(\d+)}/g, (match, index) => typeof args[index] !== 'undefined' ? args[index] : match);

